import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div'
import s from './progress-referral-card.module.scss'
import { IconChevronRight } from '@tabler/icons-react'
import { ProgressBar } from '../../../../shared/ui/progress-bar/progress-bar'
import { useProgressReferralModal } from '../../../../features/teacher/progress-info-modal/model/useProgressReferralModal'
import { useReferrals } from '@widgets/referrals/api/useReferrals'

export const ProgressReferralCard = ({referral_level, referral_levels}) => {

    const { open: openProgressReferralModal } = useProgressReferralModal()

    const { data: referrals, isFetching } = useReferrals()

    const sortedLevels = [...(referral_levels || [])].sort((a, b) => (a.min_referrals || 0) - (b.min_referrals || 0))
    const nextLevel = sortedLevels.find(el => (el.min_referrals || 0) > (referrals?.total || 0))
    const isMaxLevel = !nextLevel

    const nextNameLevel = nextLevel?.name ?? 'Твой уровень максимальный'

    const nextCountReferrals = isMaxLevel ? 0 : Math.max(0, (nextLevel?.min_referrals || 0) - (referrals?.total || 0))
    
    return (
        <FetchingDiv className={s.wrapper} isFetching={isFetching}>
            <div className={s.container}>
                <div className={s.flexRow}>
                    <p className={s.smallText}>Твой уровень</p>
                    <p className={s.smallText}>Наша комиссия</p>
                </div>
                <div className={s.flexRow}>
                    <p className={s.strongText}>{referral_level?.name} уровень</p>
                    <p className={s.strongText}>{referral_level?.commission_percent}%</p>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.flexRow}>
                    <p className={s.smallText}>{isMaxLevel ? 'Твой уровень максимальный' : 'Следующий уровень'}</p>
                    <button onClick={() => openProgressReferralModal({referral_levels, referral_level, referrals, nextCountReferrals})}>
                         {nextNameLevel} уровень <IconChevronRight size={14}></IconChevronRight>
                    </button>
                </div>
                <ProgressBar currentStep={referrals?.total} totalSteps={nextLevel?.min_referrals ?? referrals?.total ?? 5}/>    
                <p className={s.smallText}>Пригласи <span className={s.semibold}> еще {nextCountReferrals} преподавателей </span> и мы <span className={s.semibold}> снизим комиссию</span></p>
            </div>
        
        </FetchingDiv>
    )
}